var _defs, _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgUploadCircleIcon = function SvgUploadCircleIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 26 26",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#00c880;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uB808\\uC774\\uC5B4_2",
    "data-name": "\\uB808\\uC774\\uC5B4 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uB808\\uC774\\uC5B4_1-2",
    "data-name": "\\uB808\\uC774\\uC5B4 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M17,14.81a.83.83,0,0,0-.44-.05.78.78,0,0,0-.59.59.83.83,0,0,0,0,.44.75.75,0,0,0,.69.46.75.75,0,0,0,.75-.75.75.75,0,0,0-.46-.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M13,0A13,13,0,1,0,26,13,13,13,0,0,0,13,0ZM9.65,9.15l3-3h0l0,0h0l0,0h.56l0,0h0l0,0h0l3,3a.5.5,0,1,1-.7.7L13.5,7.71V13a.5.5,0,0,1-1,0V7.71L10.35,9.85a.5.5,0,1,1-.7-.7ZM20,17.5a1,1,0,0,1-1,1H7a1,1,0,0,1-1-1v-4a1,1,0,0,1,1-1h4.5V13a1.5,1.5,0,0,0,3,0v-.5H19a1,1,0,0,1,1,1Z"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgUploadCircleIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/UploadCircleIcon.4f749b27.svg";
export { ForwardRef as ReactComponent };